import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { MenuAnomalies } from '@app/features/anomalies/menu-anomalies/menu-anomalies';
import { MenuCompany } from '@app/features/companies/menu-company/menu-company';
import { MenuSalaryScale } from '@app/features/salary/menu-salary-scale/menu-salary-scale';
import { DEMO_TOUR_ID } from '@app/features/tours/demo/demo-mode';
import { MenuTours } from '@app/features/tours/menu-tours/menu-tours';
import { MenuUserButtonItem } from '@app/shared/nav/menu-user/menu-user-button-item/menu-user-button-item';
import { NavbarComponent } from '@app/shared/nav/navbar/navbar.component';
import { LucideHouse } from '@lucide/angular';
import { LayoutButtons } from '../layout/layout-buttons/layout-buttons';
import { MenuSettings } from '../menu-settings/menu-settings';
@Component({
  selector: 'app-cdt-navbar',
  imports: [
    NavbarComponent,
    MenuUserButtonItem,
    MatButtonModule,
    LucideHouse,
    MatTooltip,
    RouterLink,
    MenuSalaryScale,
    MenuCompany,
    MenuAnomalies,
    MenuTours,
    LayoutButtons,
    MenuSettings,
  ],
  templateUrl: './cdt-navbar.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./cdt-navbar.scss'],
})
export class CdtNavbar {
  /** Les anomalies viennent de l'API : un onglet de démonstration n'en a pas le menu. */
  protected readonly demo = !!inject(DEMO_TOUR_ID, { optional: true });
}
